import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Seeds the weekly summary AI response sections (top 3 highlights, risk score,
 * top risk reasons, emails needing attention) with their defaults for every org
 * that hasn't configured them yet. Anything an admin already customised is left
 * untouched, so this is safe to re-run.
 */
const backfillAiResponseSections = (callback, errCallback) => {
  return async (dispatch) => {
    dispatch({ type: 'BACKFILLING_AI_RESPONSE_SECTIONS' });
    let unsubscribe = onAuthStateChanged(auth, async (user) => {
      const token = await user?.getIdToken();
      const reqId = uuidv4();
      try {
        const response = await axios.get(
          '/ads/migration/ai-response-sections/backfill',
          {
            params: {
              requestId: reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.status === 200) {
          dispatch({ type: 'BACKFILLING_AI_RESPONSE_SECTIONS_DONE' });
          if (typeof callback === 'function') callback(response?.data);
        } else {
          dispatch({
            type: 'BACKFILLING_AI_RESPONSE_SECTIONS_FAILED',
            payload: response.data,
          });
          if (typeof errCallback === 'function') errCallback();
        }
      } catch (e) {
        console.log(e);
        dispatch({
          type: 'BACKFILLING_AI_RESPONSE_SECTIONS_FAILED',
          payload: e.message,
        });
        if (typeof errCallback === 'function') errCallback();
      }
      unsubscribe();
    });
  };
};

export default backfillAiResponseSections;
